const url = 'institutions';
import { api } from "api";
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_INST = 'LOADER_INST';
const SET_DATA_INST = 'SET_DATA_INST';
const SET_PAGE_INST = 'SET_PAGE_INST';
const SET_UPDATE_DATA_INST ='SET_UPDATE_DATA_INST';
const SET_BUSCADOR_INST = 'SET_BUSCADOR_INST';
const SET_FILTRO_INST = 'SET_FILTRO_INST';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_INST, cargando: true});
    const store = getStore();
    const search = store.institution.buscador;
    const filtro = store.institution.filtro_institution;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_INST, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_INST, data});
            dispatch({type: SET_PAGE_INST, page});
        }
        dispatch({type: LOADER_INST, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_INST, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_INST, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/institutions'))
        }
    }).then((data) => {
        dispatch({type: LOADER_INST, cargando: false});
        if(data){
            data.referent_category.value = data.referent_category.id;
            data.referent_category.label = data.referent_category.name;
            dispatch({type: SET_UPDATE_DATA_INST, updateData: data});
            dispatch(initializeForm('institution', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.institution.values;
    formData.referent_category = formData.referent_category.value;
    dispatch({type: LOADER_INST, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_INST, cargando: false})
        Swal('Éxito', 'Se ha creado la institucion.', 'success')
        .then(() => {
            dispatch(push('/institutions'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_INST, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_INST, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.institution.values);
    formData.referent_category = formData.referent_category.value;
    dispatch({type: LOADER_INST, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_INST, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/institutions'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_INST, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/institutions'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_INST, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_INST, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_INST, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_INST, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_INST, filtro_institution: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_INST]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_INST]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_INST]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_INST]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_INST]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_INST]: (state, { filtro_institution }) => {
        return {...state, filtro_institution }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_institution: null,
    updateData: {},
};
export default handleActions(reducer, initialState)
